import { render, staticRenderFns } from "./SingularitySectionLibraryModal.vue?vue&type=template&id=aa2bb5bc&"
import script from "./SingularitySectionLibraryModal.vue?vue&type=script&lang=ts&"
export * from "./SingularitySectionLibraryModal.vue?vue&type=script&lang=ts&"
import style0 from "./SingularitySectionLibraryModal.vue?vue&type=style&index=0&id=aa2bb5bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports